import React, { useContext, useEffect, useState } from "react";

import { Link as RouterLink } from "react-router-dom";

import {
    Autocomplete,
    Button,
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Grid,
    Link,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";

import EventBusyIcon from "@mui/icons-material/EventBusy";

import { stringToLocaleDateString } from "../../../../helpers";
import { UtenteLink } from "../../../common";
import { NavContext, NavRoutes } from "../../../contexts";
import { ComuniContext } from "../ComuniContext";

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

export const ComuniList = ({
    searchText,
    itemsPerPage,
    disabled,
    onLoadMore,
    onActionClick,
    ...props
}) => {
    const { getRouteTo, navigateTo } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingProvince,
        getProvinceAsync,
    } = useContext(ComuniContext);

    const { comuni, regioniOptions, provinceOptions, selectedComuni } = state;

    const editClickHandler = async (data) => {
        if (onActionClick) onActionClick("Edit", data);
    };

    const importClickHandler = async (data) => {
        if (onActionClick) onActionClick("Import", data);
    };

    const importCAPClickHandler = async (data) => {
        if (onActionClick) onActionClick("ImportCAP", data);
    };

    const addClickHandler = async (data) => {
        if (onActionClick) onActionClick("Add", data);
    };

    const [pageIndex, setPageIndex] = useState(0);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    };

    const [pageSize, setPageSize] = useState(itemsPerPage);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value);
    };

    const queryParams = new URLSearchParams(window.location.search);

    const [regioneFilter, setRegioneFilter] = useState(null);
    const [provinciaFilter, setProvinciaFilter] = useState(null);
    const [validFilter, setValidFilter] = useState(true);
    const [orphansFilter, setOrphansFilter] = useState(queryParams.get('orphans') ?? false);
    const [noCAPFilter, setNoCAPFilter] = useState(queryParams.get('noCAP') ?? false);
    const [notANPR, setNotANPR] = useState(false);
    const [dateFilter, setDateFilter] = useState(null);

    useEffect(() => {
        if (regioneFilter) getProvinceAsync(null, 0, 1000, regioneFilter);
        setProvinciaFilter(null);
    }, [regioneFilter]);

    useEffect(() => {
        if (comuni && onLoadMore) {
            onLoadMore(
                0,
                pageSize,
                searchText,
                provinciaFilter,
                regioneFilter,
                validFilter,
                orphansFilter,
                notANPR,
                null,
                noCAPFilter
            );
        }
    }, [searchText]);

    useEffect(() => {
        if (comuni && onLoadMore) {
            onLoadMore(
                pageIndex,
                pageSize,
                searchText,
                provinciaFilter,
                regioneFilter,
                validFilter,
                orphansFilter,
                notANPR,
                dateFilter,
                noCAPFilter
            );
        }
    }, [
        pageIndex,
        pageSize,
        provinciaFilter,
        regioneFilter,
        validFilter,
        orphansFilter,
        notANPR,
        dateFilter,
        noCAPFilter,
    ]);

    return (
        <div>
            <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
                sx={{ marginTop: 3 }}
            >
                {comuni ? comuni.totalCount : 0}&nbsp;Record trovati
            </Typography>
            <Card>
                <CardHeader
                    titleTypographyProps={{ variant: "h6" }}
                    title={
                        <Grid container justifyContent="space-between">
                            <Grid
                                item
                                sx={{
                                    "& .MuiInputBase-root": {
                                        color: "white",
                                    },
                                    "& .MuiFormLabel-root": {
                                        color: "white",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "white",
                                    },
                                }}
                                xs
                            >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <Typography variant="h6">Tutti i Comuni</Typography>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            color: "white !important",
                                        }}
                                    >
                                        <Grid container marginX={1}>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    options={regioniOptions}
                                                    onChange={(e, value) => {
                                                        setRegioneFilter(value?.regioneId);
                                                    }}
                                                    value={
                                                        regioniOptions.find(
                                                            (option) => option.regioneId == regioneFilter
                                                        ) ?? null
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Regione" />
                                                    )}
                                                    fullWidth
                                                    sx={{ color: "white", minWidth: 200, marginBottom: 1 }}
                                                />
                                                <Autocomplete
                                                    options={provinceOptions}
                                                    onChange={(e, value) => {
                                                        setProvinciaFilter(value?.provinciaId);
                                                    }}
                                                    value={
                                                        provinceOptions.find(
                                                            (option) => option.provinciaId == provinciaFilter
                                                        ) ?? null
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Provincia" />
                                                    )}
                                                    fullWidth
                                                    sx={{ color: "white", minWidth: 200, }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Checkbox
                                                    onChange={(e) => {
                                                        setOrphansFilter(!orphansFilter);
                                                    }}
                                                    checked={orphansFilter}
                                                    sx={{ color: "white" }}
                                                />
                                                <Typography variant="caption">ORFANI</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Checkbox
                                                    onChange={(e) => {
                                                        setNoCAPFilter(!noCAPFilter);
                                                    }}
                                                    checked={noCAPFilter}
                                                    sx={{ color: "white" }}
                                                />
                                                <Typography variant="caption">SENZA CAP</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Checkbox
                                                    onChange={(e) => {
                                                        setValidFilter(!validFilter);
                                                    }}
                                                    checked={validFilter}
                                                    sx={{ color: "white" }}
                                                />
                                                <Typography variant="caption">ATTIVI</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Checkbox
                                                    onChange={(e) => {
                                                        setNotANPR(!notANPR);
                                                    }}
                                                    checked={notANPR}
                                                    sx={{ color: "white" }}
                                                />
                                                <Typography variant="caption">NON ANPR</Typography>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs="auto" alignItems="center">
                                <Button
                                    disabled={!(selectedComuni?.length > 0)}
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    onClick={editClickHandler}
                                    sx={{ maxWidth: 100 }}
                                >
                                    Modifica provincia
                                </Button>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    onClick={importClickHandler}
                                    sx={{ marginLeft: 2 }}
                                >
                                    Importa Comuni
                                </Button>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    onClick={importCAPClickHandler}
                                    sx={{ marginLeft: 2 }}
                                >
                                    Importa CAP
                                </Button>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    color="info"
                                    onClick={addClickHandler}
                                    sx={{ marginLeft: 2 }}
                                >
                                    Aggiungi
                                </Button>
                            </Grid>
                        </Grid>
                    }
                    sx={{ backgroundColor: "secondary.main", color: "white" }}
                />
                <Divider />
                <CardContent sx={{ padding: 0 }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "aliceblue" }}>
                            <TableRow>
                                <TableCell style={{ width: "5%" }} />
                                <TableCell style={{ width: "30%" }}>Nome</TableCell>
                                <TableCell style={{ width: "10%" }}>Sigla</TableCell>
                                <TableCell style={{ width: "10%" }}>Regione</TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data istituzione
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data cessazione
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Inserito da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Modificato da
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data inserimento
                                </TableCell>
                                <TableCell align="center" style={{ width: "10%" }}>
                                    Data Modifica
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {comuni && comuni.result.length > 0 ? (
                                comuni.result.map((comune, index) => {
                                    return (
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div>
                                                        <Checkbox
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setState({
                                                                        selectedComuni: [
                                                                            ...selectedComuni,
                                                                            comune.id,
                                                                        ],
                                                                    });
                                                                } else {
                                                                    setState({
                                                                        selectedComuni: selectedComuni.filter(
                                                                            (x) => x != comune.id
                                                                        ),
                                                                    });
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div>
                                                        <Link
                                                            color="textPrimary"
                                                            onClick={() => window.open(getRouteTo(NavRoutes.Comune, [comune.id]), "_blank").focus()}
                                                            sx={{ fontWeight: 700, cursor: "pointer" }}
                                                        >
                                                            {comune.denominazioneIt}
                                                            {[
                                                                comune.provincia?.regione?.fineValidita,
                                                                comune.provincia?.fineValidita,
                                                                comune.dataCessazione,
                                                            ].some((x) => x && x <= new Date()) && (
                                                                    <EventBusyIcon
                                                                        color={
                                                                            comune.dataCessazione &&
                                                                                comune.dataCessazione <= new Date()
                                                                                ? "error"
                                                                                : "warning"
                                                                        }
                                                                    />
                                                                )}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography
                                                        color={
                                                            comune.provincia?.fineValidita &&
                                                            comune.provincia?.fineValidita <= new Date() &&
                                                            "error"
                                                        }
                                                        fontSize={14}
                                                    >
                                                        {comune.provincia?.sigla}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography
                                                        color={
                                                            comune.provincia?.regione?.fineValidita &&
                                                            comune.provincia?.regione?.fineValidita <=
                                                            new Date() &&
                                                            "error"
                                                        }
                                                        fontSize={14}
                                                    >
                                                        {comune.provincia?.regione?.descrizione}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography align="center" fontSize={14}>
                                                        {comune.dataIstituzione.toLocaleDateString("it-IT")}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography align="center" fontSize={14}>
                                                        {comune.dataCessazione
                                                            ? comune.dataCessazione.toLocaleDateString(
                                                                "it-IT"
                                                            )
                                                            : '-'}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={comune?.creatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                <UtenteLink utenteId={comune?.aggiornatoDa} />
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(comune.dataCreazione)}
                                            </TableCell>
                                            <TableCell align="center">
                                                {stringToLocaleDateString(comune.dataAggiornamento)}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        colSpan="100%"
                                        sx={{
                                            padding: 8,
                                            color: "primary.main",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        NON SONO PRESENTI COMUNI
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
                <TablePagination
                    component="div"
                    count={comuni ? comuni.totalCount : 0}
                    onPageChange={pageIndexChangeHandler}
                    onRowsPerPageChange={pageSizeChangeHandler}
                    page={pageIndex}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
        </div>
    );
};
